import React from 'react';
import PropTypes from 'prop-types';

import { PercentageInputFormatter } from 'components/shared/Formatters';
import NumberInput from './NumberInput.react';

const PercentageInput = ({ InputProps = {}, ...props }) => {
  const inputProps = {
    inputComponent: PercentageInputFormatter,
    ...InputProps,
  };
  return <NumberInput {...props} InputProps={inputProps} />;
};

PercentageInput.propTypes = {
  InputProps: PropTypes.object,
};

export default React.memo(PercentageInput);
